// Copyright © 2021 Move Closer

import { AnyObject } from '@movecloser/front-core'
import { AbstractTypeDriver } from './abstract'
import { DescriptionOfFile, DriverConfig, RelatedRecord, RelatedType, ResolvesDriver } from '../contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class FileDriver<M extends AnyObject = DescriptionOfFile, D extends AnyObject = M> extends AbstractTypeDriver<M, D> {
  /**
   * Key that stores RelatedType.
   * @protected
   */
  protected typeKey: RelatedType = RelatedType.File

  protected cdnUrl: string = 'https://cdn.defence24.pl/'

  /**
   * @inheritDoc
   */
  resolve (id: string, record: RelatedRecord, config: DriverConfig, driverResolver?: ResolvesDriver): M {
    const file = super.resolve(id, record, config, driverResolver)
    if (file.url && !file.url.startsWith('http')) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      file.url = `${this.cdnUrl}${file.url}`
    }
    return file as M
  }

  /**
   * @inheritDoc
   */
  describe (id: string, record: RelatedRecord): D {
    const file = super.describe(id, record)
    if (file.url && !file.url.startsWith('http')) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      file.url = `${this.cdnUrl}${file.url}`
    }
    return file as D
  }
}
